import React from 'react';
import { Form, Field } from 'react-final-form';
import { Grid2 } from '@mui/material';
import TextInput from '../Text';

interface QuantityPickerProps {
  value?: number;
}

const QuantityPicker: React.FC<QuantityPickerProps> = ({ value = 1, ...props }) => {
  const validateField = (): undefined => {
    return undefined; 
  };

  return (
    <Grid2 sx={{ backgroundColor: 'white' }}>
      <Form
        initialValues={{ Quantity: value }}
        onSubmit={() => {}}
        render={() => (
          <Field
            name="Quantity"
            type="number"
            validate={validateField}
            parse={(value: string) => 
              !isNaN(Number(value)) && !/[eE]/.test(value) ? Number(value) : 0
            }
            component={TextInput} 
            value={value}
            placeholder="Quantity"
            {...props}
          />
        )}
      />
    </Grid2>
  );
};

export default QuantityPicker;
